<template>
	<Treeselect
		:value="value"
		:multiple="true"
		:options="options"
		@input="$emit('input', $event)"
		openDirection="below"
		flat
		autoSelectDescendants
		autoDeselectDescendants
		clearAllText="Poista kaikki valinnat"
		clearValueText="Poista valinta"
		searchPromptText="Hae..."
		placeholder="Hae..."
		:required="true"
		:class="{ invalid: state === false, valid: state === true }"
	/>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
	props: ["options", "value", "required", "state"],
	components: {
		Treeselect
	}
};
</script>

<style lang="scss">
.vue-treeselect--open {
	.vue-treeselect__control {
		color: #495057;
		background-color: #fff;
		border-color: #80bdff;
		outline: 0;
		box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
	}

	&.valid {
		.vue-treeselect__control {
			border-color: #28a745;

			&:hover {
				border-color: #28a745 !important;
			}

			box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
		}
	}

	&.invalid {
		.vue-treeselect__control {
			border-color: #dc3545;

			&:hover {
				border-color: #dc3545 !important;
			}

			box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
		}
	}
}

.vue-treeselect {
	.vue-treeselect__control {
		border: 1px solid #ced4da;
		border-radius: 0.25rem;
	}

	&.valid {
		.vue-treeselect__control {
			border-color: #28a745;
		}
	}

	&.invalid {
		.vue-treeselect__control {
			border-color: #dc3545;
		}
	}
}

/* .vue-treeselect__control {
	border: 1px solid #ced4da;
	border-radius: 0.25rem;

	.vue-treeselect--open & {
		color: #495057;
		background-color: #fff;
		border-color: #80bdff;
		outline: 0;
		box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);

		.invalid & {
		}

		.valid & {
			border-color: #28a745;

			&:hover {
				border-color: #28a745 !important;
			}

			.vue-treeselect--open & {
				border-color: #28a745 !important;
				box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
			}
		}
	}

	.invalid & {
		border-color: #dc3545;

		&:hover {
			border-color: #dc3545 !important;
		}

		.vue-treeselect--open & {
			border-color: #dc3545 !important;
			box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
		}
	}

	.valid & {
		border-color: #28a745;

		&:hover {
			border-color: #28a745 !important;
		}

		.vue-treeselect--open & {
			border-color: #28a745 !important;
			box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
		}
	}
} */

/* .invalid {
	.vue-treeselect__control {
		border-color: #dc3545;
		&:hover {
			border-color: #dc3545 !important;
		}

		.vue-treeselect--open & {
			border-color: #dc3545 !important;
			box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
		}
	}
}
.valid {
	.vue-treeselect__control {
		border-color: #28a745;
		&:hover {
			border-color: #28a745 !important;
		}

		.vue-treeselect--open & {
			border-color: #28a745 !important;
			box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
		}
	}
} */
</style>
